import styled from "styled-components";

export const FooterContainer = styled.div`
    max-width: 100vw;
    background-color: black;
    color: white;
    overflow-x: hidden;

`
export const LogoSectionRounded = styled.div`
    padding: 10px;
    border-radius: 50%;
    background-color: white;
`